export const getPreviewSettings = ({ afterChange, initialSlide }: { afterChange: (i: any) => void; initialSlide: number }) => ({
  infinite: true,
  speed: 500,
  fade: true,
  slidesToShow: 1,
  initialSlide,
  nextArrow: <i className="fa-regular fa-chevron-right" />,
  prevArrow: <i className="fa-regular fa-chevron-left" />,
  afterChange,
});

export const thumbnailsSettings = {
  infinite: true,
  speed: 500,
  slidesToShow: 9,
  swipeToSlide: true,
  centerMode: true,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow: 6,
        infinite: true,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        infinite: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

export const customStyles = {
  height: '90vh',
  '.preview': {
    '.slick-next': {
      right: '15px',
      zIndex: 999,
    },
    '.slick-prev': {
      left: '15px',
      zIndex: 999,
    },
    '.slick-slider, .slick-list': {
      height: '100%',
    },
  },
  '.thumbs': {
    '.slick-next': {
      right: '10px',
      zIndex: 999,
    },
    '.slick-prev': {
      left: '10px',
      zIndex: 999,
    },
    '.slick-slide>div': {
      marginX: 1,
    },
  },
  '.slick-prev:before, .slick-next:before': {
    fontSize: '40px !important',
    opacity: 1,
  },
  '.slick-prev, .slick-next': {
    width: 40,
    height: 40,
  },
};
